export class AlterarSenhaAuxModel {
    id: number;
    senhaAtual: string;
    senhaNova: string;
    confirmacaoSenha: string;
}



// WEBPACK FOOTER //
// ./src/app/util/model/alterar-senha-aux.model.ts